import React from 'react';
import { handleFileDownload } from '../../../lib/utils';

const DownloadExtractButton = ({ file }) => {
    // Only show if there is a valid download link
    const hasDownload = file?.last_extraction?.download_link;
    if (!hasDownload) return null;

    return (
        <button
            className="btn btn-outline-primary btn-sm me-0 rounded-pill glow-text"
            title="Download Extract Contents"
            onClick={() => handleFileDownload(hasDownload)}
        >
            <i className="bi bi-box-arrow-down "></i>
        </button>
    );
};

export default DownloadExtractButton;
